<template>
  <v-card class="info-nav-card">
    <!-- Header -->
    <div class="info-nav-header">
      <div class="info-nav-header__icon-wrap">
        <v-icon class="info-nav-header__icon">info</v-icon>
      </div>
      <span class="info-nav-header__title">Payment Info</span>
    </div>
    <v-divider class="info-nav-divider"></v-divider>

    <!-- Nav items -->
    <v-list class="pa-0 info-nav-list">
      <v-list-tile
        v-for="item in items"
        :key="item.index"
        @click="handleClick(item.index)"
        class="info-nav-tile"
        :class="{ 'info-nav-tile--active': activeIndex === item.index }"
      >
        <v-list-tile-action>
          <v-icon small class="info-nav-tile__icon">{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title class="info-nav-tile__title">{{ item.title }}</v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon small class="info-nav-tile__arrow">chevron_right</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<script>
export default {
  data: () => ({
    activeIndex: 0,
    items: [
      {
        index: 0,
        icon: "credit_card",
        title: "Payment Information"
      }
    ]
  }),
  methods: {
    handleClick(index) {
      this.activeIndex = index;
      this.$emit("listChanged", index);
    }
  }
};
</script>

<style scoped lang="css">
.info-nav-card {
  border-radius: 14px !important;
  overflow: hidden;
}

.info-nav-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 18px;
}

.info-nav-header__icon-wrap {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  background: linear-gradient(135deg, #43A047, #2e7d32);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.info-nav-header__icon {
  color: #ffffff !important;
  font-size: 16px !important;
}

.info-nav-header__title {
  font-family: 'Inter', 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
}

.info-nav-divider {
  border-color: #f1f5f9 !important;
}

.info-nav-list {
  padding: 8px 0 !important;
}

.info-nav-tile {
  height: 48px !important;
  border-radius: 8px !important;
  margin: 2px 8px !important;
  width: calc(100% - 16px) !important;
  transition: background 0.15s ease;
}

.info-nav-tile:hover {
  background: #f8fafc !important;
}

.info-nav-tile--active {
  background: rgba(67, 160, 71, 0.08) !important;
}

.info-nav-tile__icon {
  color: #64748b !important;
}

.info-nav-tile--active .info-nav-tile__icon {
  color: #43A047 !important;
}

.info-nav-tile__title {
  font-family: 'Inter', 'Roboto', sans-serif !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  color: #334155 !important;
}

.info-nav-tile--active .info-nav-tile__title {
  color: #2e7d32 !important;
  font-weight: 600 !important;
}

.info-nav-tile__arrow {
  color: #cbd5e1 !important;
}
</style>
